import { invariant } from '@seen/core/invariant'
import type { JSX } from 'react'
import { Navigate, useParams } from 'react-router'

interface LegacyLeadRouteParams extends Record<string, string | undefined> {
  patientId?: string
}

const LEGACY_PARTICIPANTS_PATH = '/participants'

function buildLegacyLeadPatientPath(patientId: string | undefined): string {
  invariant(patientId, 'Patient ID is required for legacy lead redirection')

  return `/Patient/${patientId}`
}

export function LegacyLeadRedirectPage(): JSX.Element {
  const { patientId } = useParams<LegacyLeadRouteParams>()

  return <Navigate to={buildLegacyLeadPatientPath(patientId)} replace />
}

export function LegacyIntakeRedirectPage(): JSX.Element {
  return <Navigate to={LEGACY_PARTICIPANTS_PATH} replace />
}

export function LegacyNewLeadRedirectPage(): JSX.Element {
  return <Navigate to={LEGACY_PARTICIPANTS_PATH} replace />
}
